import React from "react";

import RenderProducts from "./RenderProducts";

import { indexAct } from "../api/indexAct";

import { Route, Link, Redirect, Switch } from "react-router-dom";

import { List, Card, Row, Col, message } from "antd";

export default class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      categories: [],
    };
  }

  componentDidMount() {
    this.getCategories();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.lang !== prevProps.lang) {
      this.getCategories();
    }
  }

  getCategories = () => {
    this.setState((prevState) => ({
      loading: true,
    }));
    indexAct("GET_CATEGORIES", {}, "/").then((data) => {
      if (data.code === 200) {
        this.setState((prevState) => ({
          loading: false,
          categories: [...data.res],
        }));
      } else {
        message.error("შეცდომა!", 5);
      }
    });
  };

  render() {
    const { categories, loading } = this.state;
    return (
      <>
        <div className="ant-segment" id="products">
          <div className="page-title-ribbon ribbon-color-1">
            <span className="page-title-ribbon-content">
              {
                this.props.info.ROUTES.find((el) => el.COMPONENT === "Products")
                  .PAGE_NAME
              }
            </span>
          </div>
          <div className="page-content">
            <List
              loading={loading}
              className="category-list"
              grid={{
                gutter: [16],
                xs: 2,
                sm: 2,
                md: 3,
                lg: 5,
                xl: 5,
                xxl: 5,
              }}
              pagination={false}
              dataSource={categories}
              renderItem={(item, i) => {
                const image =
                  item.CATEGORY_IMAGE.length > 5
                    ? `${window.APP.MEDIA}categories/${item.CATEGORY_IMAGE}`
                    : `${window.APP.MEDIA}no-image.png`;
                return (
                  <List.Item>
                    <Card
                      bodyStyle={{ display: "none" }}
                      cover={
                        <Link to={`/products/${item.CATEGORY_URL}`}>
                          <div
                            style={{
                              position: "relative",
                              textAlign: "center",
                              fontFamily: "HeadFont",
                              color: "#fff",
                              width: "100%",
                              height: "100%",
                            }}
                          >
                            <img
                              alt={item.CATEGORY_NAME}
                              style={{ width: "100%" }}
                              src={image}
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                width: "100%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                background: "rgba(0, 0, 0, 0.5)",
                              }}
                            >
                              <Row justify="center" align="middle">
                                <Col span={24}>
                                  <div className="category-font-size">
                                    {item.CATEGORY_NAME}
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </Link>
                      }
                    />
                  </List.Item>
                );
              }}
            />
          </div>
        </div>
        <Switch>
          <Route
            exact
            path="/products/:name"
            render={(props) => {
              return <RenderProducts {...this.props} {...props} />;
            }}
            //component={RenderProducts}
          />
          <Redirect from="*" to="/" />
        </Switch>
      </>
    );
  }
}
